/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressApiModel } from './addressApiModel';


export interface EmployeeDetailApiModelNew { 
    id: number;
    titleBeforeName: string;
    name: string;
    surname: string;
    titleAfterName: string;
    dateOfBirth: string;
    address: string;
    email: string;
    phoneNumber: string;
    birthNumber: string;
    personalNumber: string;
    active: boolean;
    hasEntryExamination: boolean;
    addressDto: AddressApiModel;
    age: number;
}

